import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
// css comes in published_hw.css

import AssessPopupBox from "../Three_Dot_Popup_Box/AssessPopupBox";
import { BookText, CalendarDays, MoreVertical } from "lucide-react";
const PublishAssessBoxHW = (props) => {
  const reduceParaGraph = (text, length) => {
    if (text.length < length) {
      return text;
    }

    return text.substring(0, length) + "...";
  };
  const { setIsDeactivated } = props;
  return (
    // <Link to={`/PublishedQListHW/${props.id}`} className="link">
    <div
      className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
      style={{
        backgroundColor: "#FDEFE3",
        borderTop: "2px solid #8D4B28",
        borderRight: "4px solid #8D4B28",
        borderBottom: "1px solid #8D4B28",
        borderLeft: "1px solid #8D4B28",
        borderRadius: "0.75rem",
      }}
    >
      {/* Header: Class | Section | Subject + 3 Dots */}
      <div className="d-flex justify-content-between align-items-start mb-2">
        <NavLink
          to={{ pathname: `/PublishedQListHW` }}
          className="text-dark fw-semibold text-decoration-none"
          state={{ homework_id: props.id }}
        >
          {props?.standard} – {props?.section} |{" "}
          <span title={props?.published_subject} className="poppins-semibold">
            {reduceParaGraph(props?.published_subject, 27)}
          </span>
        </NavLink>

        <Popup
          trigger={<MoreVertical size={18} style={{ cursor: "pointer" }} />}
          content={
            <div className="p-2">
              <AssessPopupBox
                props={props}
                setIsDeactivated={setIsDeactivated}
              />
            </div>
          }
          on="click"
          hideOnScroll
          position="bottom right"
        />
      </div>

      {/* Assessment Name */}
      <NavLink
        to={{ pathname: `/PublishedQListHW` }}
        className="text-decoration-none text-dark"
        state={{ homework_id: props.id }}
      >
        <div className="d-flex align-items-center mb-1">
          <BookText size={16} className="me-2 text-dark" />
          <div className="text-truncate poppins-semibold">
            {props.published_assessName}
          </div>
        </div>

        {/* Deadline */}
        <div
          className="d-flex align-items-center text-muted"
          style={{ fontSize: "0.875rem" }}
        >
          <CalendarDays size={16} className="me-2 text-dark" />
          <div>
            <span className="me-1">Deadline:</span>
            <span className=" text-dark">{props.deadline}</span>
          </div>
        </div>
      </NavLink>
    </div>
  );
};
export default PublishAssessBoxHW;
